<template>
  <div class="web">
    <div class="pc-box">
      <!-- 头部 -->
      <div class="pc-header">
        <div class="pc-header-auto">
          <span>
            <img src="@/assets/logo.png" @click="$router.push('/venueDetail-pc')">
            <em>订单详情</em>
          </span>
        </div>
      </div>

      <!-- 内容区 -->
      <div class="pc-content">
        <!-- 页面标题与面包屑 -->
        <div class="page-nav">
          <a-breadcrumb>
            <a-breadcrumb-item><a @click="$router.push('/venueDetail-pc')">首页</a></a-breadcrumb-item>
            <a-breadcrumb-item><a @click="$router.push('/orderIndex-pc')">预约列表</a></a-breadcrumb-item>
            <a-breadcrumb-item>订单详情</a-breadcrumb-item>
          </a-breadcrumb>
        </div>

        <div class="order-detail-grid">
          <!-- 左侧：订单详细信息 -->
          <div class="order-main-info">
            <section class="info-group">
              <div class="group-header">
                <a-icon type="file-text" class="group-icon" />
                <span class="group-title">预约信息</span>
                <a-tag :color="getStatusColor(record.status)" class="status-tag">
                  {{ getStatusText(record.status) }}
                </a-tag>
              </div>

              <div class="descriptions-wrapper">
                <a-descriptions :column="2" bordered size="middle">
                  <a-descriptions-item label="订单编号">{{ record.orderNo }}</a-descriptions-item>
                  <a-descriptions-item label="下单时间">{{ record.addTime }}</a-descriptions-item>
                  <a-descriptions-item label="场馆名称">{{ record.groundName }}</a-descriptions-item>
                  <a-descriptions-item label="场地类型">{{ record.sportType }}</a-descriptions-item>
                  <a-descriptions-item label="预约手机">{{ record.mobileNum }}</a-descriptions-item>
                  <a-descriptions-item label="是否包场">{{ record.isEnclosure === '1' ? '是' : '否' }}</a-descriptions-item>
                  <a-descriptions-item label="预约场次" :span="2">
                    <div class="session-slots-pc">
                      <div class="slot-item-pc" v-for="(item, index) in record.orderDetailVos" :key="index">
                        <a-icon type="clock-circle" style="margin-right: 8px; color: #883032;" />
                        {{ item.timeSlot }}
                      </div>
                    </div>
                  </a-descriptions-item>
                  <a-descriptions-item label="订单备注" :span="2">
                    {{ record.orderRemark || '无' }}
                  </a-descriptions-item>
                </a-descriptions>
              </div>
            </section>

            <section class="info-group" v-if="record.serviceVos && record.serviceVos.length > 0">
              <div class="group-header">
                <a-icon type="shopping-cart" class="group-icon" />
                <span class="group-title">附加服务</span>
              </div>
              <div class="table-wrapper-pc">
                <a-table
                  :columns="serviceColumns"
                  :data-source="record.serviceVos"
                  :pagination="false"
                  rowKey="id"
                  size="middle"
                >
                  <span slot="price" slot-scope="text">￥0.00</span>
                  <span slot="total" slot-scope="text, row">￥0.00</span>
                </a-table>
              </div>
            </section>
          </div>

          <!-- 右侧：状态、支付与核销 -->
          <div class="order-side-actions">
            <!-- 核销卡片 -->
            <div class="side-card qrcode-card">
              <div class="side-card-title">核销凭证</div>
              <div class="qrcode-pc-area">
                <div id="qrcode-pc"></div>
                <div class="exchange-code-val">{{ record.exchangeCode }}</div>
                <p class="qrcode-helper">入场时请向管理员出示此码</p>
              </div>
            </div>

            <!-- 费用与操作卡片 -->
<!--            <div class="side-card settlement-card">-->
<!--              <div class="action-btns-pc">-->
<!--                <template v-if="record.status === '0'">-->
<!--                  <a-button type="danger" size="large" block :disabled="paying" :loading="paying" @click="payOrder" class="pay-btn-pc">-->
<!--                    立即支付-->
<!--                    <a-statistic-countdown v-if="!paying" :value="deadline" format="mm:ss" class="inline-countdown" @finish="refresh" />-->
<!--                  </a-button>-->
<!--                </template>-->

<!--                <div class="document-btns" v-if="['1', '2', '3'].includes(record.status) && record.payType === '2'">-->
<!--                  <a-button icon="download" block @click="downInventory" class="doc-btn">下载结算单</a-button>-->
<!--                  <a-button v-if="record.inventoryUrl" icon="link" block @click="jump(record.inventoryUrl)" class="doc-btn">-->
<!--                    预约报销链接-->
<!--                  </a-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>

      <div class="foot">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import QRCode from 'qrcodejs2'
import { FILE_DISPLAY_PREFIX } from '@/api/upload'
import { getDictByType } from '@/api/common'
import { getDictName } from '@/utils/common'
import { get, downInventory, pay } from '@/api/order/order'
import {
  Card, Descriptions, Tag, Table, Divider, Button, Row, Col,
  Statistic, message, Breadcrumb, Icon
} from 'ant-design-vue'

export default {
  name: 'OrderDetailPc',
  components: {
    'a-card': Card,
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item,
    'a-tag': Tag,
    'a-table': Table,
    'a-divider': Divider,
    'a-button': Button,
    'a-row': Row,
    'a-col': Col,
    'a-statistic-countdown': Statistic.Countdown,
    'a-breadcrumb': Breadcrumb,
    'a-breadcrumb-item': Breadcrumb.Item,
    'a-icon': Icon
  },
  data() {
    return {
      id: '',
      record: {},
      deadline: 0,
      paying: false,
      qrcodeLoading: true,
      serviceColumns: [
        { title: '服务项目', dataIndex: 'serviceName', key: 'serviceName' },
        { title: '单价', dataIndex: 'price', key: 'price', scopedSlots: { customRender: 'price' } },
        { title: '数量', dataIndex: 'num', key: 'num', align: 'center' },
        { title: '小计', key: 'total', align: 'right', scopedSlots: { customRender: 'total' } }
      ],
      interval: null
    }
  },
  created() {
    this.id = this.$route.query.id
    this.refresh()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getDetail()
    }, 10000)
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    refresh() {
      this.getDetail()
    },
    getDetail() {
      this.qrcodeLoading = true
      get(this.id).then(res => {
        if (res.code === 10000) {
          this.record = res.result

          if (this.record.status === '0') {
            const applyTime = moment(this.record.addTime, 'YYYY-MM-DD HH:mm:ss').valueOf()
            this.deadline = applyTime + 1000 * 60 * 15
          }

          this.$nextTick(() => {
            if (this.record.exchangeCode) {
              const container = document.getElementById('qrcode-pc')
              if (container) {
                container.innerHTML = ''
                new QRCode("qrcode-pc", {
                  text: this.record.exchangeCode,
                  width: 180,
                  height: 180,
                  colorDark: "#333333",
                  colorLight: "#ffffff",
                  correctLevel: QRCode.CorrectLevel.H
                })
              }
            }
            this.qrcodeLoading = false
          })
        }
      }).catch(() => {
        this.qrcodeLoading = false
      })
    },
    getStatusText(status) {
      const statusMap = { '0': '待支付', '1': '待核销', '2': '已完成', '3': '已评价', '4': '已取消' }
      return statusMap[status] || '未知状态'
    },
    getStatusColor(status) {
      const colorMap = { '0': 'orange', '1': 'blue', '2': 'green', '3': 'cyan', '4': 'gray' }
      return colorMap[status] || 'default'
    },
    payOrder() {
      if (this.paying) return
      this.paying = true
      this.qrcodeLoading = true  // 支付开始时显示加载状态
      const params = {
        id: this.record.id,
        payType: '1'
      }
      pay(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('支付成功')
          this.refresh()
          setTimeout(() => {
            this.paying = false
          }, 500)
        } else {
          this.$message.error(res.message || '支付失败')
          this.paying = false
          this.qrcodeLoading = false
        }
      }).catch(() => {
        this.$message.error('支付失败')
        this.paying = false
        this.qrcodeLoading = false
      })
    },
    downInventory() {
      downInventory(this.record.id).then(res => {
        if (res.code === 10000) {
          message.success('结算单下载请求已提交')
        }
      })
    },
    jump(url) {
      if (url) window.location.href = url
    }
  }
}
</script>

<style scoped>
.web {
  background: #f0f2f5;
  min-height: 100vh;
}
.pc-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  width: 100%;
  height: 80px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  position: sticky;
  top: 0;
  z-index: 1000;
}
.pc-header-auto {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pc-header-auto span {
  display: flex;
  align-items: center;
}
.pc-header-auto span img {
  width: 160px;
  height: 40px;
  cursor: pointer;
}
.pc-header-auto span em {
  display: flex;
  height: 24px;
  align-items: center;
  border-left: 1px solid #e8e8e8;
  margin-left: 16px;
  padding-left: 16px;
  font-weight: 500;
  font-size: 18px;
  color: #333;
}
.pc-content {
  width: 1200px;
  margin: 24px auto;
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  min-height: calc(100vh - 160px);
}
.page-nav {
  margin-bottom: 32px;
}
.order-detail-grid {
  display: flex;
  gap: 32px;
}
.order-main-info {
  flex: 1;
  min-width: 0;
}
.info-group {
  margin-bottom: 40px;
}
.group-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}
.group-icon {
  font-size: 20px;
  color: #883032;
  margin-right: 12px;
}
.group-title {
  font-size: 20px;
  font-weight: bold;
  color: #262626;
}
.status-tag {
  margin-left: 16px;
  padding: 0 12px;
  height: 28px;
  line-height: 26px;
  font-size: 14px;
}
.descriptions-wrapper {
  background: #fff;
}
.session-slots-pc {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.slot-item-pc {
  padding: 6px 16px;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 4px;
  color: #c53030;
  font-size: 14px;
}
.table-wrapper-pc {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}

.order-side-actions {
  width: 340px;
}
.side-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}
.side-card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #262626;
  padding-left: 12px;
  border-left: 4px solid #883032;
}
.qrcode-pc-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}
.qrcode-loading {
  width: 180px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  border-radius: 8px;
}
.exchange-code-val {
  font-size: 28px;
  font-weight: 800;
  margin-top: 20px;
  color: #262626;
  letter-spacing: 3px;
  font-family: 'Courier New', Courier, monospace;
}
.qrcode-helper {
  color: #8c8c8c;
  margin-top: 8px;
  font-size: 14px;
}

.settlement-details {
  padding: 10px 0;
}
.settle-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  color: #595959;
  font-size: 15px;
}
.discount-row {
  color: #38a169;
}
.settle-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}
.settle-total span:first-child {
  font-weight: bold;
  font-size: 16px;
  color: #262626;
}
.final-price {
  font-size: 32px;
  font-weight: 800;
  color: #883032;
}

.action-btns-pc {
  margin-top: 32px;
}
.pay-btn-pc {
  height: 56px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
}
.inline-countdown {
  display: inline-block;
  margin-left: 12px;
}
/deep/ .inline-countdown .ant-statistic-content {
  color: #fff;
  font-size: 18px;
  line-height: 1;
}
.document-btns {
  margin-top: 16px;
}
.doc-btn {
  margin-top: 12px;
  height: 44px;
  border-radius: 6px;
}

.foot {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}
</style>
